import { useEffect, useRef } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Transaction } from 'components/TransactionAllocator';
import { PartnerTransfersFormValues } from '../../hooks/usePartnerTransfersForm';

type GroupedTransactions = {
  actionId: string;
  actionName: string;
  transactions: Array<Transaction>;
};

type UseInitializeCapitalActionTransactionsProps = {
  linkedGroupedTransactions: Array<GroupedTransactions>;
  generalGroupedTransactions: Array<GroupedTransactions>;
  advanceSubscriptionsGroupedTransactions: Array<GroupedTransactions>;
  savedTransactions?: Record<string, Array<Transaction>>;
  formMethods: UseFormReturn<PartnerTransfersFormValues>;
};

export const useInitializeCapitalActionTransactions = ({
  linkedGroupedTransactions,
  generalGroupedTransactions,
  advanceSubscriptionsGroupedTransactions,
  savedTransactions,
  formMethods,
}: UseInitializeCapitalActionTransactionsProps) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!savedTransactions && !hasInitialized.current) {
      const allTransactions: Record<string, Array<Transaction>> = {};

      linkedGroupedTransactions.forEach((group) => {
        allTransactions[group.actionId] = group.transactions;
      });

      generalGroupedTransactions.forEach((group) => {
        allTransactions[group.actionId] = group.transactions;
      });

      advanceSubscriptionsGroupedTransactions.forEach((group) => {
        allTransactions[group.actionId] = group.transactions;
      });

      if (Object.keys(allTransactions).length > 0) {
        formMethods.setValue('capitalActionTransactions', allTransactions);
        hasInitialized.current = true;
      }
    }
  }, [
    linkedGroupedTransactions,
    generalGroupedTransactions,
    advanceSubscriptionsGroupedTransactions,
    savedTransactions,
    formMethods,
  ]);
};
